module.exports = __webpack_public_path__ + "img/cog.f1c9f21a.svg";